import React, {useCallback, useContext, useEffect, useState} from "react";
import {HttpStatus, useWait} from "../../utils/wait_fn";
import {HttpServer} from "../../net/http_server";
import {ClaimsProvider} from "../claims/list";
import {useHistory, useParams} from "react-router-dom";
import {PageInatWidegt} from "../../widget/pub/paginat_widget";
import {ClaimsListCell} from "../../interface/claims/claims_list_cell";
import {useClaimApply} from "../claims/fn/use_claim_apply";
import {useSendModal} from "../../model/http_loading";
import {SuccessWidget} from "../personal/arbitration/success_widget";
import {formatAddress} from "../../utils/formatBalance";
import {DateUtils} from "../../utils/date";
import {StatusWidget} from "../claims/widget/status";
import {ButtonWidget} from "../../widget/pub/button_widget";
import {CellStyle, LoadingWidget, NullStyle, WapStyle} from "../claims/list/main_list_widget";

export const ADMIN_TYPE = 'admin';

export const BottomWidget: React.FC = () => {
    // const [page,setPage] = useState(1);

    const params = useParams<{ type: string, }>();

    const {request, data, status} = useWait<any>(HttpServer.claimListAdmin);
    const {setTopData} = useContext(ClaimsProvider)
    const history = useHistory();
    useEffect(() => {
        request(params.type)
    }, [params.type])

    useEffect(() => {
        if (data != null)
            setTopData(data);
    }, [data])

    return (
        <div>
            <WapStyle>
                <div className={'bar padding'}>
                    <div>Claim ID</div>
                    <div>CLAIM BY</div>
                    <div>Submitted</div>
                    <div>Product</div>
                    <div>State</div>
                    {/*<div>Assessors/total</div>*/}
                    <div>Action</div>
                </div>
                <div className={'main'}>
                    {
                        status === HttpStatus.success ?
                            (data?.claim_list || data?.list) ? (data?.claim_list || data?.list).map((ev: any, i: number) =>
                                <CellWidget
                                    key={'iddasd' + i} bg={i % 2 !== 0}
                                    onClick={() => history.push(`/${ADMIN_TYPE}/msgpage/${ev.claim_id}`)}
                                    model={ev}/>) : <NullStyle>N/A</NullStyle> :
                            [0, 0, 0, 0, 0, 0].map((ev, i) => <LoadingWidget key={'iddasd' + i} bg={i % 2 !== 0}/>)
                    }
                </div>
            </WapStyle>
        </div>
    );
}

const CellWidget: React.FC<{ bg: boolean, model: ClaimsListCell, onClick: Function }> = ({bg, model, onClick}) => {
    const [status, setStaus] = useState(model.status);

    const params = useParams<{ type: string, }>();

    const history = useHistory();

    const historyPush = useCallback(() => history.push(`/${ADMIN_TYPE}/arbitration/${model.claim_id}?type=${params.type}`), []);


    return (
        <CellStyle bg={bg} className={'padding cell'} onClick={() => onClick()}>
            <div>{model.claim_id}</div>
            <div>{formatAddress(model.user_id)}</div>
            <div>{DateUtils.dataString(model.submit_at)}</div>
            <div>{model.product}</div>
            <div><StatusWidget status={status}/></div>
            <div>

                <ButtonWidget onClick={(e) => {
                    historyPush();
                    e.stopPropagation()
                }}
                              bgColor={'#0064FD'}
                              text={'Action'}
                              size={{x: 7, y: 15}}
                />
            </div>
        </CellStyle>
    );
}

